// Used to pass image compression parameters to Contentful image sources
// See: https://www.contentful.com/developers/docs/references/graphql/#/reference/schema-generation/assets
export const configureImageSrc = (src: string, width = 500) => {
  const quality = 100;
  const format = 'webp';

  return `${src}?w=${width}&q=${quality}&fm=${format}`;
};
